import { z } from "zod";
import { TranslationMapSchema } from "./surveys";

export const DomainWithQuestionsResponseSchema = z.object({
  id: z.string(),
  key: z.string(),
  text: TranslationMapSchema,
  createdAt: z.coerce.date(),
  questions: z.array(
    z.object({ id: z.string(), text: TranslationMapSchema, type: z.string() }),
  ),
});
export type DomainWithQuestionsResponse = z.infer<
  typeof DomainWithQuestionsResponseSchema
>;

export const createDomainSchemas = {
  params: z.object({ surveyId: z.string() }),
  body: z.object({ key: z.string().min(1), text: TranslationMapSchema }),
  response: {
    201: z.object({
      id: z.string(),
      key: z.string(),
      text: TranslationMapSchema,
      createdAt: z.coerce.date(),
    }),
  },
};
export type CreateDomainParams = z.infer<typeof createDomainSchemas.params>;
export type CreateDomainInput = z.infer<typeof createDomainSchemas.body>;

export const listDomainsSchemas = {
  params: z.object({ surveyId: z.string() }),
  querystring: z.object({
    page: z.coerce.number().int().nonnegative().optional(),
    pageSize: z.coerce.number().int().positive().optional(),
  }),
  response: {
    200: z.object({
      domains: z.array(
        z.object({
          id: z.string(),
          key: z.string(),
          text: TranslationMapSchema,
          createdAt: z.coerce.date(),
        }),
      ),
      totalPages: z.number(),
      currentPage: z.number(),
    }),
  },
};
export type ListDomainsParams = z.infer<typeof listDomainsSchemas.params>;
export type ListDomainsQuery = z.infer<typeof listDomainsSchemas.querystring>;

export const getDomainSchemas = {
  params: z.object({ surveyId: z.string(), domainId: z.string() }),
  response: { 200: DomainWithQuestionsResponseSchema },
};
export type GetDomainParams = z.infer<typeof getDomainSchemas.params>;

export const updateDomainSchemas = {
  params: z.object({ surveyId: z.string(), domainId: z.string() }),
  body: z.object({ text: TranslationMapSchema }),
  response: {
    200: z.object({
      id: z.string(),
      key: z.string(),
      text: TranslationMapSchema,
      createdAt: z.coerce.date(),
    }),
  },
};
export type UpdateDomainParams = z.infer<typeof updateDomainSchemas.params>;
export type UpdateDomainInput = z.infer<typeof updateDomainSchemas.body>;

export const deleteDomainSchemas = {
  params: z.object({ surveyId: z.string(), domainId: z.string() }),
  response: { 204: z.undefined() },
};
export type DeleteDomainParams = z.infer<typeof deleteDomainSchemas.params>;
